/**
 * Labstep
 *
 * @module components/Device/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { DeviceActionDeleteProps } from './types';

export const DeviceActionDelete: React.FC<
  DeviceActionDeleteProps
> = ({ device }) => <EntityActionDelete entity={device} />;
